// Actions
export const setPayment = ({ commit }, payload) => {
  commit('SET_PAYMENT', payload)
}
export const addPayment = ({ commit }, payload) => {
  commit('ADD_PAYMENT', payload)
}
export const setPaymentLoading = ({ commit }, payload) => {
  commit('SET_PAYMENT_LOADING', payload)
}

export const setStockOption = ({ commit }, payload) => {
  commit('SET_STOCK_OPTION', payload)
}
export const addStockOption = ({ commit }, payload) => {
  commit('ADD_STOCK_OPTION', payload)
}
export const setStockOptionLoading = ({ commit }, payload) => {
  commit('SET_STOCK_OPTION_LOADING', payload)
}
export const setKitPartners = ({ commit }, payload) => {
  commit('SET_KIT_PARTNERS', payload)
}
export const addKitPartners = ({ commit }, payload) => {
  commit('ADD_KIT_PARTNERS', payload)
}
export const setKitPartnersLoading = ({ commit }, payload) => {
  commit('SET_KIT_PARTNERS_LOADING', payload)
}

export const setStatusKitPartners = ({ commit }, payload) => {
  commit('SET_STATUS_KIT_PARTNERS', payload)
}
export const addStatusKitPartners = ({ commit }, payload) => {
  commit('ADD_STATUS_KIT_PARTNERS', payload)
}
export const setStatusKitPartnersLoading = ({ commit }, payload) => {
  commit('SET_STATUS_KIT_PARTNERS_LOADING', payload)
}

export const setStatusKitClients = ({ commit }, payload) => {
  commit('SET_STATUS_KIT_CLIENTS', payload)
}
export const addStatusKitClients = ({ commit }, payload) => {
  commit('ADD_STATUS_KIT_CLIENTS', payload)
}
export const setStatusKitClientsLoading = ({ commit }, payload) => {
  commit('SET_STATUS_KIT_CLIENTS_LOADING', payload)
}

export const setTipoKitPartners = ({ commit }, payload) => {
  commit('SET_TIPO_KIT_PARTNERS', payload)
}
export const addTipoKitPartners = ({ commit }, payload) => {
  commit('ADD_TIPO_KIT_PARTNERS', payload)
}
export const setTipoKitPartnersLoading = ({ commit }, payload) => {
  commit('SET_TIPO_KIT_PARTNERS_LOADING', payload)
}

export const setProfessionalKitPartners = ({ commit }, payload) => {
  commit('SET_PROFESSIONAL_KIT_PARTNERS', payload)
}
export const addProfessionalKitPartners = ({ commit }, payload) => {
  commit('ADD_PROFESSIONAL_KIT_PARTNERS', payload)
}
export const setProfessionalKitPartnersLoading = ({ commit }, payload) => {
  commit('SET_PROFESSIONAL_KIT_PARTNERS_LOADING', payload)
}

export const setClientKitPartners = ({ commit }, payload) => {
  commit('SET_CLIENT_KIT_PARTNERS', payload)
}
export const addClientKitPartners = ({ commit }, payload) => {
  commit('ADD_CLIENT_KIT_PARTNERS', payload)
}
export const setClientKitPartnersLoading = ({ commit }, payload) => {
  commit('SET_CLIENT_KIT_PARTNERS_LOADING', payload)
}

export const setDocumentsKitPartners = ({ commit }, payload) => {
  commit('SET_DOCUMENTS_KIT_PARTNERS', payload)
}
export const addDocumentsKitPartners = ({ commit }, payload) => {
  commit('ADD_DOCUMENTS_KIT_PARTNERS', payload)
}
export const setDocumentsKitPartnersLoading = ({ commit }, payload) => {
  commit('SET_DOCUMENTS_KIT_PARTNERS_LOADING', payload)
}
export const setConjuntoKitPartners = ({ commit }, payload) => {
  commit('SET_CONJUNTO_KIT_PARTNERS', payload)
}
export const addConjuntoKitPartners = ({ commit }, payload) => {
  commit('ADD_CONJUNTO_KIT_PARTNERS', payload)
}
export const setConjuntoKitPartnersLoading = ({ commit }, payload) => {
  commit('SET_CONJUNTO_KIT_PARTNERS_LOADING', payload)
}

export const setOpcoesKitPartners = ({ commit }, payload) => {
  commit('SET_OPCOES_KIT_PARTNERS', payload)
}
export const addOpcoesKitPartners = ({ commit }, payload) => {
  commit('ADD_OPCOES_KIT_PARTNERS', payload)
}
export const setOpcoesKitPartnersLoading = ({ commit }, payload) => {
  commit('SET_OPCOES_KIT_PARTNERS_LOADING', payload)
}

export const setPjKitPartners = ({ commit }, payload) => {
  commit('SET_PJ_KIT_PARTNERS', payload)
}
export const addPjKitPartners = ({ commit }, payload) => {
  commit('ADD_PJ_KIT_PARTNERS', payload)
}
export const setPjKitPartnersLoading = ({ commit }, payload) => {
  commit('SET_PJ_KIT_PARTNERS_LOADING', payload)
}

export const setVinculoKitPartners = ({ commit }, payload) => {
  commit('SET_VINCULO_KIT_PARTNERS', payload)
}
export const addVinculoKitPartners = ({ commit }, payload) => {
  commit('ADD_VINCULO_KIT_PARTNERS', payload)
}
export const setVinculoKitPartnersLoading = ({ commit }, payload) => {
  commit('SET_VINCULO_KIT_PARTNERS_LOADING', payload)
}
